import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommandResult } from '../models/commandResult';
import { Security } from '../utils/security.util';

@Injectable({
  providedIn: 'root'
})
export class CityService {

  constructor(private http: HttpClient) { }

  get(){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/city/get', this.options());
  }

  options() {
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${Security.getToken()}`)
    .set('api-version', Security.versionApi());
  return { headers };
  }
}
